export default "__VITE_ASSET__DFWHbJrm__"